<div class="wrap">
  <div class="head">
    <div class="title">Contribute via</div>
    <div class="badge cards"><div class="icon"><app-icon name="cards" [size]="26" /></div><div class="text">All Credit & Debit Cards</div></div>
    <div class="badge bank"><div class="icon"><app-icon name="globe" [size]="19" /></div><div class="text">Net Banking</div></div>
  </div>
  <button class="donate" (click)="donateNow('card-bank')" matRipple>Contribute Now</button>
  <ng-container>
    <ng-container *ngTemplateOutlet="separator" />
    <div class="upi-option">
      <div class="options">
        <div *ngFor="let option of upiOptions" class="upi-item">
          <div class="icon {{option.mode}}" (click)="donateNow(option.mode)" matRipple></div>
          <div class="text">{{option.label}}</div>
        </div>
      </div>
      <div class="other">
        <button class="view-all" (click)="donateNow('other-upi')" matRipple>View other UPIs</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="bankInfo?.account_number">
    <ng-container *ngTemplateOutlet="separator" />
    <div class="bank-option">
      <div class="top-title">
        <div class="icon"><app-icon name="bank" [size]="63" /></div>
        <div class="text">Transfer directly to the Bank account of this Fundraiser</div>
      </div>
      <div class="bank-details">
        <div class="acc-num"><span class="label">{{ 'Stories.bankTransfer.virtualAccNo' | translatePipe | async }}</span><strong>: </strong><span class="value">{{bankInfo?.account_number}}</span></div>
        <div class="acc-name"><span class="label">{{ 'Stories.bankTransfer.virtualAccName' | translatePipe | async }}</span><strong>: </strong><span class="value">{{bankInfo?.name}}-Ketto</span></div>
        <div class="type"><span class="label">{{ 'Stories.bankTransfer.accountType' | translatePipe | async }}</span><strong>: </strong><span class="value">{{ 'Stories.bankTransfer.current' | translatePipe | async }}</span></div>
        <div *ngIf="bankInfo?.ifsc" class="code"><span class="label">{{ 'Stories.bankTransfer.ifsc' | translatePipe | async }}</span><strong>: </strong><span class="value">{{bankInfo?.ifsc}}</span></div>
        <div *ngIf="bankInfo?.ifsc_character">(The Digit after {{bankInfo?.ifsc_character}} is zero)</div>
      </div>
    </div>
  </ng-container>
</div>
<div class="claim">
  Claim your contribution acknowledgement now! For  payment done via <span (click)="openAcknowlegementModal('bank')">Bank Transfer</span> or <span (click)="openAcknowlegementModal('upi')">UPI</span>
</div>

<ng-template #separator>
  <div class="separator"><div class="hrLine"></div>OR<div class="hrLine"></div></div>
</ng-template>

<ng-template #paymentModule>
  <app-payment *ngIf="fundraiser"
    [internal]="true"
    [fundraiser]="fundraiser"
    [origin]="origin"
    [showBeneficiary]="showBeneficiary"
    [type]="'full'"
    [isBtnClicked]="isBtnClicked"
    [headerType]="'v1'"
  />
</ng-template>
